'use strict';

import angular from 'angular';
import Data from './data.controller';

export default angular.module('bfastCaptureManagerApp.application.data', [])
  .controller('AppDataController', Data)
  .name;



// WEBPACK FOOTER //
// ./client/app/application/data/index.js